import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage, defineMessages, injectIntl, useIntl } from 'react-intl';
import { FormikChips, FormikCheckbox, FormikMultiSelect } from '../../../components/prime-formik';

import FormLanguageSelector from '../../../components/formik-components/FormLanguageSelector';
import { renderAsyncSelector } from '../../../components/formik-components/FormAsyncSelector';
import { validateEmails } from '../../../i18n/common';
import useCustomFunctionalityCheck from '../../../hooks/useCustomFunctionalityCheck';

const i18n = defineMessages({
  choose: {
    id: 'choose',
    defaultMessage: 'Choose',
  },
  printerFriendly: {
    id: 'superlink.lbl_printer_friendly_report',
    defaultMessage: 'Printer friendly report(s)',
  },
  emailPlaceholder: {
    id: 'placeholder.email',
    defaultMessage: 'Email Address',
  },
});

const NewAssessementFormOptions = ({ activeLocales, jobSearching, jobs, searchJob }) => {
  const { formatMessage } = useIntl();
  const { setFieldValue } = useFormikContext();

  const { getReportsToAutomaticallyGenerate } = useCustomFunctionalityCheck();
  const reportsToAutomaticallyGenerate = getReportsToAutomaticallyGenerate();

  const printerFriendly = formatMessage(i18n.printerFriendly);
  const emailPlaceholder = formatMessage(i18n.emailPlaceholder);
  return (
    <Fragment>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <label className="field-label" htmlFor="emails">
            <FormattedMessage id="superlink.notificationEmail" defaultMessage="Send auto-generated report(s) to" />
          </label>
          <Field
            id="emails"
            name="emails"
            component={FormikChips}
            setFieldValue={setFieldValue}
            validate={(e) => validateEmails(e, formatMessage)}
            placeholder={emailPlaceholder}
            addOnBlur
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <label className="field-label" htmlFor="superlink-reports">
            <FormattedMessage
              id="superlink.autogenerateReports"
              defaultMessage="Auto-generate reports (Target Job required)"
            />
          </label>
          <Field
            setFieldValue={setFieldValue}
            options={reportsToAutomaticallyGenerate}
            component={FormikMultiSelect}
            id="autogenerateReports"
            name="autogenerateReports"
            placeholder={`- ${formatMessage(i18n.choose)} -`}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <label className="field-label" htmlFor="targetJob">
            <FormattedMessage id="attrs.targetJob" defaultMessage="Target Job Profile" />
          </label>
          <Field
            id="targetJob"
            name="targetJob"
            component={renderAsyncSelector}
            processing={jobSearching}
            data={jobs}
            filter
            valueField="id"
            textField="name"
            onSearch={searchJob}
            setFieldValue={setFieldValue}
            placeholder={`- ${formatMessage(i18n.choose)} -`}
          />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <FormattedMessage id="attrs.locale" defaultMessage="Preferred Language">
            {(text) => (
              <label className="field-label" htmlFor="superlink-reportLang">
                {text}
              </label>
            )}
          </FormattedMessage>
          <Field id="locale" name="locale" component={FormLanguageSelector} options={activeLocales} />
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col">
          <Field
            id="printerFriendlyReport"
            name="printerFriendlyReport"
            component={FormikCheckbox}
            labelText={printerFriendly}
            setFieldValue={(fieldName, selectedValue) => {
              setFieldValue(fieldName, selectedValue, false);
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

NewAssessementFormOptions.propTypes = {
  activeLocales: PropTypes.arrayOf(PropTypes.any).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.any).isRequired,
  jobSearching: PropTypes.bool.isRequired,
  searchJob: PropTypes.func.isRequired,
};

export default injectIntl(NewAssessementFormOptions);
